import React from "react";
import { RouteComponentProps } from "react-router";
import { Box, Button, Container, TextField } from "@material-ui/core";
import logo from "../../../assets/ReadleeLogoRed.png";
import "./ForgotPasswordScreen.css";
import FirebaseService from "../../../services/firebase/FirebaseService";
import { RootState } from "../../../state/configureStore";
import { connect } from "react-redux";
import Loading from "../../Loading/Loading";
import InformationModal from "../../Modals/InformationModal";
import { closeInformationModal, showInformationModal } from "../../Modals/InformationModalReducer";
import LoadingButton from "../../Loading/LoadingButton";
import { EMAIL_MAX_LENGTH } from "../../../utils/stringFormatting";

// local state for email input and button
type ForgotState = {
  email: string;
  loadingButtonState: LoadingButton;
};

type ForgotPasswordScreenProps = ReturnType<typeof mapStateToProps> & RouteComponentProps;
class ForgotPasswordScreen extends React.Component<ForgotPasswordScreenProps, ForgotState> {
  constructor(props: ForgotPasswordScreenProps) {
    super(props);

    this.state = {
      email: "",
      loadingButtonState: LoadingButton.BeforeLoading,
    };
  }

  changeLoadingButtonState = (loadingState: LoadingButton) => {
    this.setState(state => {
      return {
        ...state,
        loadingButtonState: loadingState,
      };
    });
  };

  // Change input
  onChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    this.setState(state => {
      return {
        ...state,
        [event.target.id]: event.target.value,
      };
    });
  }

  // Send request to Firebase auth
  onSubmit() {
    if (this.state?.email?.length ?? 0) {
      FirebaseService.sendPasswordResetEmail(this.state?.email).then(res => {
        showInformationModal("", res);
      });
    } else {
      showInformationModal("", "Please enter your email.");
    }
    // this.changeLoadingButtonState(LoadingButton.BeforeLoading);
  }

  override componentDidUpdate() {
    if (this.props.currentUserState.currentUser !== undefined) {
      this.props.history.replace("/Home");
    }
  }

  override render() {
    if (this.props.currentUserState.isConnectingUser || this.props.currentUserState.isConnectingSettings) {
      return <Loading />;
    }

    return (
      <Container className="ForgotPasswordScreen" style={{ backgroundColor: "white" }}>
        <div className="general">
          <Box height={80} />
          <img src={logo} alt="Readlee" height={30} />
          <Box height={35} />
          <div style={{ fontWeight: "bolder", fontSize: "larger" }}>Forgot Password?</div>
          <Box height={15} />
          <div style={{ marginBottom: "5px" }}>Enter the email address you used to register and</div>
          <div>we'll email you the password reset instructions.</div>
          <Box height={40} />
          <TextField
            className="input-field"
            variant="outlined"
            id="email"
            label="Email"
            onChange={e => this.onChange(e)}
            required
            inputProps={{ maxLength: EMAIL_MAX_LENGTH }}
          />
          <Box height={40} />

          <Button
            variant="contained"
            className="SubmitButton"
            onClick={this.onSubmit.bind(this)}
            color="primary"
            // changeLoadingButtonState={this.changeLoadingButtonState} buttonClickText={'Send Reset Instructions'}
            // buttonFinishedText={'Send Reset Instructions'} loadingButtonState={this.state.loadingButtonState}
            // clickHandler={this.onSubmit}
          >
            {" "}
            Send Reset Instructions{" "}
          </Button>
        </div>
        <InformationModal
          title={this.props.informationModalState.title}
          onOk={closeInformationModal}
          open={this.props.informationModalState.isOpen}
        >
          {this.props.informationModalState.message}
        </InformationModal>
      </Container>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  currentUserState: state.currentUserState,
  informationModalState: state.informationModalState,
});

export default connect(mapStateToProps)(ForgotPasswordScreen);
